"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrendMobileUp = function TrendMobileUp() {
  return _react2.default.createElement(
    "g",
    { id: "trend-mobile-up", fill: "#83c215" },
    _react2.default.createElement("polygon", {
      id: "Shape",
      points: "178.224619 249.35 178.224619 500 321.015386 500 321.015386 249.35 435.25 249.35 249.620002 0 64 249.35"
    })
  );
};

exports.default = TrendMobileUp;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/TrendMobileUp.js
// module id = 3002
// module chunks = 4